// src/pages/AdminProdutos/AdminProdutos.js
import React, { useState, useEffect } from 'react';
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebaseConfig'; // Caminho para seu firebaseConfig.js
import { Link } from 'react-router-dom';
import ProdutoForm from './ProdutoForm'; // Importa o formulário de produto
import ProdutoItemAdmin from './ProdutoItemAdmin'; // Importa o item de produto para admin
import './AdminProdutos.css'; // Estilos para esta página

function AdminProdutos() {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [produtoParaEditar, setProdutoParaEditar] = useState(null); // Estado para guardar o produto que está sendo editado

  // Função para buscar produtos do Firebase
  const buscarProdutos = async () => {
    try {
      setLoading(true);
      setError(null);
      const q = query(collection(db, "produtos"), orderBy("nome", "asc")); // Ordena por nome
      const querySnapshot = await getDocs(q);
      const produtosDoFirestore = [];
      querySnapshot.forEach((doc) => {
        produtosDoFirestore.push({ id: doc.id, ...doc.data() });
      });
      setProdutos(produtosDoFirestore);
    } catch (err) {
      console.error("Erro ao buscar produtos:", err);
      setError("Erro ao carregar produtos. Verifique sua conexão.");
    } finally {
      setLoading(false);
    }
  };

  // Executa a busca de produtos ao carregar o componente
  useEffect(() => {
    buscarProdutos();
  }, []);

  // Função para adicionar um novo produto (recebe os dados do formulário)
  const handleAdicionarProduto = async (novoProduto) => {
    try {
      // Garante que o novo produto tenha o campo ativoPDV
      const produtoComAtivo = { ...novoProduto, ativoPDV: novoProduto.ativoPDV !== undefined ? novoProduto.ativoPDV : true };
      await addDoc(collection(db, "produtos"), produtoComAtivo);
      alert('Produto adicionado com sucesso!');
      buscarProdutos(); // Recarrega a lista de produtos
    } catch (e) {
      console.error("Erro ao adicionar produto: ", e);
      alert('Erro ao adicionar produto. Tente novamente.');
    }
  };

  // Função para editar um produto existente (recebe o ID e os novos dados do formulário)
  const handleEditarProduto = async (id, dadosAtualizados) => {
    try {
      const produtoRef = doc(db, "produtos", id);
      await updateDoc(produtoRef, dadosAtualizados);
      alert('Produto atualizado com sucesso!');
      setProdutoParaEditar(null); // Limpa o formulário de edição
      buscarProdutos(); // Recarrega a lista
    } catch (e) {
      console.error("Erro ao atualizar produto: ", e);
      alert('Erro ao atualizar produto. Tente novamente.');
    }
  };

  // Função para ativar/desativar o produto no PDV
  const handleToggleAtivoPDV = async (id, ativoPDVAtual) => {
    try {
      const produtoRef = doc(db, "produtos", id);
      await updateDoc(produtoRef, { ativoPDV: !ativoPDVAtual });
      buscarProdutos(); // Recarrega a lista
    } catch (e) {
      console.error("Erro ao alternar ativoPDV: ", e);
      alert('Erro ao alterar status. Tente novamente.');
    }
  };

  // Função para deletar um produto
  const handleDeletarProduto = async (id) => {
    if (window.confirm("Tem certeza que deseja deletar este produto? Esta ação é irreversível!")) {
      try {
        const produtoRef = doc(db, "produtos", id);
        await deleteDoc(produtoRef);
        alert('Produto deletado com sucesso!');
        buscarProdutos(); // Recarrega a lista
      } catch (e) {
        console.error("Erro ao deletar produto: ", e);
        alert('Erro ao deletar produto. Tente novamente.');
      }
    }
  };

  return (
    <div className="admin-container">
      <h2>Gerenciamento de Produtos</h2>
      <Link to="/pdv" className="voltar-pdv-btn">← Voltar para o PDV</Link>
      <Link to="/historico" className="ir-historico-btn">Ver Histórico →</Link>

      <h3>{produtoParaEditar ? 'Editar Produto' : 'Adicionar Novo Produto'}</h3>
      <ProdutoForm
        onSubmit={produtoParaEditar ? handleEditarProduto : handleAdicionarProduto}
        produtoInicial={produtoParaEditar}
        onCancelar={() => setProdutoParaEditar(null)} // Cancela edição
      />

      <h3>Lista de Produtos</h3>
      {loading && <p>Carregando produtos...</p>}
      {error && <p className="erro-mensagem">{error}</p>}

      {!loading && !error && produtos.length === 0 && (
        <p>Nenhum produto cadastrado ainda.</p>
      )}

      {!loading && !error && produtos.length > 0 && (
        <div className="lista-produtos-admin">
          {produtos.map((produto) => (
            <ProdutoItemAdmin
              key={produto.id}
              produto={produto}
              onEdit={() => setProdutoParaEditar(produto)} // Preenche o formulário para edição
              onToggleAtivoPDV={handleToggleAtivoPDV}
              onDelete={handleDeletarProduto}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default AdminProdutos;